const flags = [
    { title:'UK', registrationPlace: 'UK', languageId: 'english', value: '1' },
    { title:'australia', registrationPlace: 'AU', languageId: 'australian', value: '6' },
    { title: 'norway', registrationPlace: 'NO', languageId: 'norwegian', value: '5' },
    { title:'ireland', registrationPlace: 'IE', languageId: 'irish', value: '4' },
];

export default flags;